import { Badge } from "@/components/ui/badge";
import type { InvoiceStatus } from "@/features/invoices/types";
import { cn } from "@/lib/utils";

const statusClassName: Record<InvoiceStatus, string> = {
  DRAFT: "border-border bg-muted text-muted-foreground",
  OPEN: "border-info/20 bg-info/10 text-info",
  PAID: "border-success/20 bg-success/10 text-success",
  VOID: "border-destructive/20 bg-destructive/10 text-destructive",
};

export function InvoiceStatusBadge({ status }: { status: InvoiceStatus }) {
  return (
    <Badge variant="outline" className={cn("text-[11px] font-bold uppercase", statusClassName[status])}>
      {status}
    </Badge>
  );
}
